module.exports = __webpack_public_path__ + "static/img/qznn_3d_s.01c75cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/qznn_3d_s.png
// module id = pPjQ
// module chunks = 0